const appNames = () => {
  const appName = "Help Center"
  const appIdentifierName = "mfa-help-center"

  return { appName, appIdentifierName }
}

export default appNames
